import { useState, useEffect } from "react";
import { F, D } from "../../../styles/palette";
import { DC, Bdg } from "../../shared";
import useAuditLog from "../../../hooks/useAuditLog";

const ACCIONES = [
  "", "crear_paciente", "actualizar_paciente", "crear_evolucion", "subir_foto",
  "aceptar_consentimiento", "aprobar_medico", "revocar_medico", "login", "logout",
  "ver_expediente", "cambiar_rol", "reset_totp", "suspender_usuario", "reactivar_usuario",
  "revocar_dispositivos",
];

const ENTIDADES = ["", "patient", "clinical_record", "photo", "consent", "user"];

const ACCION_COLORS = {
  crear_paciente: "#16a34a", actualizar_paciente: "#0284c7", crear_evolucion: "#38bdf8",
  subir_foto: "#7c3aed", aceptar_consentimiento: "#fb923c", aprobar_medico: "#16a34a",
  revocar_medico: "#dc2626", login: "#64748b", logout: "#475569", cambiar_rol: "#ca8a04",
  reset_totp: "#ea580c", suspender_usuario: "#dc2626", reactivar_usuario: "#16a34a",
};

export default function AdminAuditLog({ user }) {
  const { logs, loading, hasMore, loadLogs, loadMore, exportCSV } = useAuditLog();
  const [filters, setFilters] = useState({ accion: "", entidad: "", dateFrom: "", dateTo: "", userId: "" });
  const [expanded, setExpanded] = useState(null);

  useEffect(() => { loadLogs({}); }, [loadLogs]);

  const applyFilters = () => {
    const f = {};
    if (filters.accion) f.accion = filters.accion;
    if (filters.entidad) f.entidad = filters.entidad;
    if (filters.dateFrom) f.dateFrom = filters.dateFrom;
    if (filters.dateTo) f.dateTo = filters.dateTo;
    if (filters.userId) f.userId = filters.userId;
    loadLogs(f);
  };

  const clearFilters = () => {
    setFilters({ accion: "", entidad: "", dateFrom: "", dateTo: "", userId: "" });
    loadLogs({});
  };

  const selectStyle = {
    padding: "7px 10px", borderRadius: 7, border: `1px solid ${D.bdr}`,
    background: "rgba(30,41,59,0.8)", color: "#e2e8f0", fontSize: 12, fontFamily: F.b,
  };

  const inputStyle = {
    ...selectStyle, width: "100%", boxSizing: "border-box",
  };

  return (
    <div>
      {/* Filters */}
      <DC title="Filtros" accent="#38bdf8">
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 10 }}>
          <div>
            <label style={{ color: "#94a3b8", fontSize: 11, display: "block", marginBottom: 3 }}>Acción</label>
            <select value={filters.accion} onChange={e => setFilters(p => ({ ...p, accion: e.target.value }))} style={selectStyle}>
              <option value="">Todas</option>
              {ACCIONES.filter(Boolean).map(a => <option key={a} value={a}>{a.replace(/_/g, " ")}</option>)}
            </select>
          </div>
          <div>
            <label style={{ color: "#94a3b8", fontSize: 11, display: "block", marginBottom: 3 }}>Entidad</label>
            <select value={filters.entidad} onChange={e => setFilters(p => ({ ...p, entidad: e.target.value }))} style={selectStyle}>
              <option value="">Todas</option>
              {ENTIDADES.filter(Boolean).map(e => <option key={e} value={e}>{e}</option>)}
            </select>
          </div>
          <div>
            <label style={{ color: "#94a3b8", fontSize: 11, display: "block", marginBottom: 3 }}>User ID</label>
            <input type="text" value={filters.userId} onChange={e => setFilters(p => ({ ...p, userId: e.target.value }))}
              placeholder="UID del usuario" style={inputStyle} />
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr auto auto", gap: 8, alignItems: "end" }}>
          <div>
            <label style={{ color: "#94a3b8", fontSize: 11, display: "block", marginBottom: 3 }}>Desde</label>
            <input type="date" value={filters.dateFrom} onChange={e => setFilters(p => ({ ...p, dateFrom: e.target.value }))} style={inputStyle} />
          </div>
          <div>
            <label style={{ color: "#94a3b8", fontSize: 11, display: "block", marginBottom: 3 }}>Hasta</label>
            <input type="date" value={filters.dateTo} onChange={e => setFilters(p => ({ ...p, dateTo: e.target.value }))} style={inputStyle} />
          </div>
          <button onClick={applyFilters}
            style={{ padding: "8px 16px", borderRadius: 7, border: "none", background: D.ac, color: "#020617", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: F.b }}>
            Filtrar
          </button>
          <button onClick={clearFilters}
            style={{ padding: "8px 16px", borderRadius: 7, border: `1px solid ${D.bdr}`, background: "transparent", color: "#94a3b8", fontSize: 12, cursor: "pointer", fontFamily: F.b }}>
            Limpiar
          </button>
        </div>
      </DC>

      {/* Export */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
        <span style={{ color: "#64748b", fontSize: 12, fontFamily: F.m }}>{logs.length} registros</span>
        <button onClick={exportCSV} disabled={logs.length === 0}
          style={{ padding: "6px 14px", borderRadius: 7, border: `1px solid ${D.bdr}`, background: "transparent", color: logs.length ? D.ac : "#475569", fontSize: 11, cursor: logs.length ? "pointer" : "default", fontFamily: F.b }}>
          Exportar CSV
        </button>
      </div>

      {/* Loading */}
      {loading && logs.length === 0 && <p style={{ color: D.txM, fontSize: 13, textAlign: "center", padding: 20 }}>Cargando...</p>}

      {!loading && logs.length === 0 && <DC><p style={{ color: D.txM, fontSize: 13, textAlign: "center" }}>No hay registros de auditoría</p></DC>}

      {/* Log entries */}
      {logs.map((l, i) => {
        const isExp = expanded === i;
        const fecha = l.timestamp?.toDate ? l.timestamp.toDate() : null;
        const color = ACCION_COLORS[l.accion] || "#94a3b8";
        return (
          <div key={l.id || i} onClick={() => setExpanded(isExp ? null : i)}
            style={{ background: D.card, border: `1px solid ${D.bdr}`, borderRadius: 10, padding: "10px 14px", marginBottom: 4, cursor: "pointer", backdropFilter: "blur(12px)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                <Bdg t={l.accion?.replace(/_/g, " ") || "?"} c={color} />
                <span style={{ color: "#94a3b8", fontSize: 11 }}>{l.entidad}</span>
                <span style={{ color: "#64748b", fontSize: 11 }}>{l.userEmail || l.userId?.slice(0, 10)}</span>
              </div>
              <span style={{ color: "#475569", fontSize: 10, fontFamily: F.m }}>
                {fecha ? fecha.toLocaleDateString("es-CO", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" }) : ""}
              </span>
            </div>
            {l.detalles && <p style={{ color: "#64748b", fontSize: 11, margin: "4px 0 0", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: isExp ? "normal" : "nowrap" }}>{l.detalles}</p>}

            {isExp && (
              <div style={{ marginTop: 8, borderTop: `1px solid ${D.bdr}`, paddingTop: 8 }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 4, fontSize: 10, fontFamily: F.m }}>
                  <div style={{ color: "#64748b" }}>Entidad ID: <span style={{ color: "#94a3b8" }}>{l.entidadId || "—"}</span></div>
                  <div style={{ color: "#64748b" }}>User ID: <span style={{ color: "#94a3b8" }}>{l.userId || "—"}</span></div>
                  {l.hashAntes && <div style={{ color: "#64748b" }}>Hash antes: <span style={{ color: "#94a3b8" }}>{l.hashAntes.slice(0, 24)}...</span></div>}
                  {l.hashDespues && <div style={{ color: "#64748b" }}>Hash después: <span style={{ color: "#94a3b8" }}>{l.hashDespues.slice(0, 24)}...</span></div>}
                </div>
              </div>
            )}
          </div>
        );
      })}

      {hasMore && (
        <div style={{ textAlign: "center", marginTop: 12 }}>
          <button onClick={loadMore} disabled={loading}
            style={{ padding: "8px 24px", borderRadius: 8, border: `1px solid ${D.bdr}`, background: "transparent", color: D.ac, fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: F.b }}>
            {loading ? "Cargando..." : "Cargar más"}
          </button>
        </div>
      )}
    </div>
  );
}
